module.exports = __webpack_public_path__ + "img/tree_layer_2.5c4b3a61.png";